import { useGetAllAccountsUsersCountQuery } from '../features/vpnAccounts/vpnAccountsApiSlice';


const options = {
   "accountUsersCount": useGetAllAccountsUsersCountQuery
}

export const pagination = {
    options: options
}